import {Injectable} from '@angular/core';
import {AuthService} from '@auth0/auth0-angular';
import * as signalR from '@microsoft/signalr';
import {ToastrService} from 'ngx-toastr';
import {Observable, Subject, catchError, throwError} from 'rxjs';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SignalRService {
  constructor(private auth: AuthService, private notifier: ToastrService) {}
  public connections: signalR.HubConnection[] = [];
  private url = environment.API + 'Notification';
  private salaryIncreaseUrl = environment.AccountingAPI + 'SalaryIncreaseSocket';
  public signalRSubject = new Subject<string>();

  signalRObservable(): Observable<string> {
    this.auth.getAccessTokenSilently().subscribe(result => {
      const options: signalR.IHttpConnectionOptions = {
        transport: signalR.HttpTransportType.WebSockets,
        accessTokenFactory: () => result,
      };

      this.connections[0] = new signalR.HubConnectionBuilder()
        .withUrl(this.url, options)
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Information)
        .build();

      this.connections[1] = new signalR.HubConnectionBuilder()
        .withUrl(this.salaryIncreaseUrl, options)
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Information)
        .build();

      for (const connection of this.connections) {
        connection.on('SendMessage', (str: string) => {
          this.signalRSubject.next(str);
        });

        connection.onclose((err?: Error) => {
          err ? this.signalRSubject.error(err) : this.signalRSubject.complete();
        });

        connection.start().catch(err => this.signalRSubject.error(err));
      }
    });

    return this.signalRSubject.pipe(
      catchError(error => {
        this.notifier.error(`Something went wrong with WebSocket`);
        return throwError(() => error);
      })
    );
  }
}
